import { render, staticRenderFns } from "./additionalData.vue?vue&type=template&id=c4d80484&scoped=true"
import script from "./additionalData.vue?vue&type=script&lang=js"
export * from "./additionalData.vue?vue&type=script&lang=js"
import style0 from "./additionalData.vue?vue&type=style&index=0&id=c4d80484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d80484",
  null
  
)

export default component.exports